import { SimpleFormField } from "../components/SimpleFormField";
import { Button } from "react-bootstrap";
import { getDB } from "../util/db";
import { useNavigate, useParams } from "react-router";
import { emptyArray, getRandomId, setNavAdvisoryLockout } from "../util/utils";
import { useEffect, useState } from "react";
import { useProfile } from "../components/ProfileContext";
import { QuestionEditorForm } from "../forms/QuestionEditorForm";
import { LoadingComponent } from "../components/LoadingComponent";
import { Job } from "../models/Job";
import { Share } from "react-bootstrap-icons";
import { SharingFormModal } from "../forms/SharingFormModal";

export function JobEditPage(props) {
	setNavAdvisoryLockout(true);

	let params = useParams();
	let jobId = params.jobId;
	let navigate = useNavigate();
	let [profile, setProfile] = useProfile();

	let [job, setJob] = useState(null)
	let [jobQuestions, setJobQuestions] = useState(job?.jobQuestions || emptyArray);
	let [showSharingDialog, setShowSharingDialog] = useState(false);

	if(jobId == null && job == null) {
		setJob({
			id: getRandomId(),
			name: "",
			jobQuestions: []
		});
	}

	useEffect(async () => {
		if(jobId != null && job == null) {
			let newJob = await Job.find(jobId);
			setJob(newJob);
			setJobQuestions(newJob.jobQuestions);
		}	
	});
	
	let saveAction = async () => {
		// Post to server
		try {
			let savedJobData = await Job.saveJob(profile, job);

			// Save locally
			let db = await getDB();
			await db.put("Jobs", savedJobData);

			// Return to listing
			navigate(`/jobs`);
		} catch(err) {
			alert(`Unable to save job: ${err}`);
		}
	}

	let deleteJobAction = async () => {
		if(confirm("Are you sure you want to delete this job?")) {
			try {
				await Job.deleteJob(profile, job);
				let db = await getDB();
				await db.delete("Jobs", job.id);

				navigate("/jobs");
			} catch(err) {
				alert(`Unable to delete job: ${err}`);
			}
		}
	};

	let duplicateAction = async () => {
		let db = await getDB();

		let newJob = Object.assign(new Job(), job); // Just a shallow assign but should work fine for this purpose

		newJob.id = getRandomId();
		newJob.name = `${job.name} Copy`;

		try {
			newJob = await Job.saveJob(profile, newJob);
			// Save locally
			await db.put("Jobs", newJob);
			navigate(`/jobs`); // Redirecting here was causing problems - just avoiding it
		} catch(err) {
			alert(`Error saving new job: ${err}`);
		}
	};

	let cancelAction = () => {
		if(confirm("Are you sure you want to cancel your changes?")) {
			navigate(`/jobs`);
		}
	};

	let shareAction = () => {
		setShowSharingDialog(!showSharingDialog);
	};

	if(job == null) {
		return <LoadingComponent />;
	}

	return (
		<div className="jobEditPageContainer">
			<h1>
				{!!jobId ? "Edit Job" : "New Job"}
				<Button onClick={saveAction} className="m-1 float-end">Save</Button>
				{!!jobId && <Button variant="danger" className="m-1 float-end" onClick={deleteJobAction}>Delete</Button>}
				{!!jobId && <Button variant="secondary" className="m-1 float-end" onClick={duplicateAction}>Duplicate</Button>}
				<Button variant="secondary" className="m-1 float-end" onClick={cancelAction}>Cancel</Button>
				{job.userIdentifier == profile.id.toString() && <Button className="m-1 float-end" onClick={shareAction}><Share /></Button>}
			</h1>
			<SharingFormModal show={showSharingDialog} setShow={setShowSharingDialog} sharingObject={job} profile={profile} />
			<div className="clearfix"></div>
			<h2>Basic Information</h2>
			<SimpleFormField label="Job Name" placeholder="Job Name" bindObject={job} bindAttribute="name" />
			<SimpleFormField label="Company" placeholder="Acme Corporation" bindObject={job} bindAttribute="companyName" />
			<SimpleFormField label="Location" placeholder="Anytown, USA" bindObject={job} bindAttribute="location" />
			<SimpleFormField label="Contact" placeholder="John Doe" bindObject={job} bindAttribute="contactName" />
			<SimpleFormField label="Phone" placeholder="555-123-4567" bindObject={job} type="tel" bindAttribute="contactPhone" />
			<SimpleFormField label="Email" placeholder="example@email.com" bindObject={job} type="email" bindAttribute="contactEmail" />
			<SimpleFormField label="Address" placeholder="1600 Pennsylvania Avenue NW, Washington, D.C." bindObject={job} bindAttribute="contactAddress" />

			<h2 className="mt-4">Job-Specific Questions</h2>
			<QuestionEditorForm bindObject={job} questionsAttribute="jobQuestions" emptyText="No job questions defined." />
		</div>
	)
}